import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { extractErrorMessage } from "../util";
import {GetAllJobsParams, JobData, JobState, UpdateJobData} from "../types";
import Cookies from "js-cookie";
import { get } from "http";

axios.defaults.withCredentials = true;

const base_url = process.env.REACT_APP_BASE_URL;
//token
// const headerToken = Cookies.get("token");

const initialState: JobState = {
  error: null,
  isLoading: true,
  jobs: null,
  singleJob: null,
  questionCategory: null,
  questions: null,
  jobTypes: null,
  singleJobType:null,
  salaryTypes: null,
  singleSalaryType: null,
  singleQuestionCategory: null,
  singleQuestion:null,
  jobQuestionAndAnswer:null
};


export const getJobQuestionAndAnswer = createAsyncThunk(
  "api/getJobQuestionAndAnswer",
  async (id: number, thunkAPI) => {
      const headerToken = Cookies.get("token")
    try {
      const response = await axios.get(`${base_url}/getJobQuestionAndAnswer/${id}`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
)


export const deleteSalaryType = createAsyncThunk(
  "api/deleteSalaryType",
  async (id: number, thunkAPI) => {
      const headerToken = Cookies.get("token")
    try {
      const response = await axios.delete(`${base_url}/salaryTypes/${id}`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
)

export const updateSalaryType = createAsyncThunk(
  "api/updateSalaryType",
  async (data: any, thunkAPI) => {
      const headerToken = Cookies.get("token")
    try {
      const response = await axios.put(`${base_url}/salaryTypes/${data.id}`, data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  } 
)

export const getSalaryTypeById = createAsyncThunk(
  "api/getSalaryTypeById",
  async (id: any, thunkAPI) => {
      const headerToken = Cookies.get("token")
    try {
      const response = await axios.get(`${base_url}/salaryTypes/${id}`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
)

export const addSalaryType = createAsyncThunk(
  "api/addSalaryType",
  async (data: any, thunkAPI) => {
      const headerToken = Cookies.get("token")
    try {
      const response = await axios.post(`${base_url}/salaryTypes`, data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
)

export const getSalaryTypes = createAsyncThunk(
  "api/getSalaryTypes",
  async (_, thunkAPI) => {
      const headerToken = Cookies.get("token")
    try {
      const response = await axios.get(`${base_url}/salaryTypes`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
)

export const toggleSalaryTypeStatus = createAsyncThunk(
  "api/toggleSalaryTypeStatus",
  async (data: any, thunkAPI) => {
      const headerToken = Cookies.get("token")
    try {
      const response = await axios.post(`${base_url}/toggleSalaryStatus`, data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
)

export const deleteJobType = createAsyncThunk(
  "api/deleteJobType",
  async (id: number, thunkAPI) => {
      const headerToken = Cookies.get("token")
    try {
      const response = await axios.delete(`${base_url}/jobTypes/${id}`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
)

export const getJobTypeById = createAsyncThunk(
  "api/getJobTypeById",
  async (id: any, thunkAPI) => {
      const headerToken = Cookies.get("token")
    try {
      const response = await axios.get(`${base_url}/jobTypes/${id}`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  } 
)


export const toggleJobTypeStatus = createAsyncThunk(
  "api/toggleJobTypeStatus",
  async (data:any, thunkAPI) => {
      const headerToken = Cookies.get("token")
    try {
      const response = await axios.post(`${base_url}/toggleJobStatus`, data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  } 
)
export const updateJobType = createAsyncThunk(
  "api/updateJobType",
  async (data: any, thunkAPI) => {
      const headerToken = Cookies.get("token")
    try {
      const response = await axios.put(`${base_url}/jobTypes/${data.id}`, data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
)


export const getJobTypes = createAsyncThunk(
  "api/getJobTypes",
  async (_, thunkAPI) => {
      const headerToken = Cookies.get("token")
    try {
      const response = await axios.get(`${base_url}/jobTypes`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
)
export const addJobType = createAsyncThunk(
  "api/addJobType",
  async (data: any, thunkAPI) => {
      const headerToken = Cookies.get("token")
    try {
      const response = await axios.post(`${base_url}/jobTypes`, data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
)

export const sendJobEmail = createAsyncThunk(
  "api/sendJobEmail",
  async (data: any, thunkAPI) => {
      const headerToken = Cookies.get("token")
    try {
      const response = await axios.post(`${base_url}/sendJobAlert`, data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
);

export const getAllJobs = createAsyncThunk<any, GetAllJobsParams>(
    "api/getAllJobs",
    async ({ search = "", per_page = 20 }: GetAllJobsParams, thunkAPI) => {
        const headerToken = Cookies.get("token");

        try {
            const response = await axios.get(`${base_url}/getAllJobs`, {
                withCredentials: true,
                headers: {
                    Authorization: `Bearer ${headerToken}`,
                },
                params: {
                    search,
                    per_page,
                },
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(extractErrorMessage(error));
        }
    }
);

export const addJob = createAsyncThunk(
  "api/addjobs",
  async (data: JobData, thunkAPI) => {

      const headerToken = Cookies.get("token")
    try {
      const response = await axios.post(`${base_url}/addJob`, data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
);

export const getJobById = createAsyncThunk(
  "api/getJobById",
  async (id: any, thunkAPI) => {

      const headerToken = Cookies.get("token")
    try {
      const response = await axios.get(`${base_url}/jobs/edit/${id}`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
);

export const updateJob = createAsyncThunk(
  "api/updateJob",
  async (data: UpdateJobData | any, thunkAPI) => {

      const headerToken = Cookies.get("token")
    try {
      const response = await axios.put(`${base_url}/updateJob/${data.jobId}`, data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
);

export const updateJobStatus = createAsyncThunk(
  "api/updateJobStatus",
  async (data: any, thunkAPI) => {

      const headerToken = Cookies.get("token")
    try {
      const response = await axios.put(`${base_url}/updateJobstatus`, data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
);


export const updateJobSingleStatus = createAsyncThunk(
  "api/updateJobSingleStatus",
  async (data: any, thunkAPI) => {

      const headerToken = Cookies.get("token")
    try {
      const response = await axios.put(`${base_url}/updateJobSingleStatus`, data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
);


export const changeJobStatus = createAsyncThunk(
  "api/changeJobStatus",
  async (data: any, thunkAPI) => {

      const headerToken = Cookies.get("token")
    try {
      const response = await axios.post(`${base_url}/changeJobStatus`, data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
);



export const getQuestionCategoryById = createAsyncThunk(
  "api/getQuestionCategoryById",
  async (id: string | undefined, thunkAPI) => {
      const headerToken = Cookies.get("token")
    try {
      const response = await axios.get(`${base_url}/question-categories/${id}`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
);  

export const getQuestionCategory = createAsyncThunk(
  "api/getQuestionCategory",
  async (_, thunkAPI) => {

      const headerToken = Cookies.get("token")
    try {
      const response = await axios.get(`${base_url}/question-categories`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
);


export const addQuestionCategory = createAsyncThunk(
  "api/addQuestionCategory",
  async (data: any, thunkAPI) => {
    
      const headerToken = Cookies.get("token")
    try {
      const response = await axios.post(`${base_url}/question-categories`, data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
)

export const addQuestion = createAsyncThunk(
  "api/addQuestion",
  async (data: any, thunkAPI) => {
      const headerToken = Cookies.get("token")
    try {
      const response = await axios.post(`${base_url}/pre-questions`, data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }

  })

  export const deleteQuestion = createAsyncThunk(
  "api/deleteQuestion",
  async (id: string | undefined, thunkAPI) => {
      const headerToken = Cookies.get("token")
    try {
      const response = await axios.delete(`${base_url}/pre-questions/${id}`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
  )

  export const updateQuestion = createAsyncThunk(
  "api/updateQuestion",
  async (data: any, thunkAPI) => {
      const headerToken = Cookies.get("token")
    try {
      const response = await axios.put(`${base_url}/pre-questions/${data.id}`, data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
  )

  export const getQuestionById = createAsyncThunk(
  "api/getQuestionById",
  async (id: string | undefined, thunkAPI) => {
      const headerToken = Cookies.get("token")
    try {
      const response = await axios.get(`${base_url}/pre-questions/${id}`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
  )

export const getQuestions = createAsyncThunk(
  "api/getQuestions",
  async (categoryId: string | undefined, thunkAPI) => {

      const headerToken = Cookies.get("token")
    try {
      const response = await axios.get(
        `${base_url}/getpreQuestion/${categoryId}`,
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${headerToken}`,
          },
        }
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
);

// Redux slice for authentication
const jobSlice = createSlice({
  name: "job",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addJob.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addJob.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(addJob.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      .addCase(getAllJobs.pending, (state, action) => {
        state.isLoading = true;
        state.jobs = null;
      })
      .addCase(getAllJobs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jobs = action.payload;
      })
      .addCase(getJobById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.singleJob = action.payload;
      })
      .addCase(getQuestionCategory.fulfilled, (state, action) => {
        state.questionCategory = action.payload;
        state.isLoading = false;
      })
      .addCase(getQuestions.fulfilled, (state, action) => {
        state.questions = action.payload;
        state.isLoading = false;
      })
      .addCase(getJobTypes.fulfilled, (state, action) => {
        state.jobTypes = action.payload;
        state.isLoading = false;
      })
       .addCase(getSalaryTypes.fulfilled, (state, action) => {
        state.salaryTypes = action.payload;
        state.isLoading = false;
      })
      .addCase(getJobTypeById.fulfilled, (state, action) => {
        state.singleJobType = action.payload;
        state.isLoading = false;
      })
      .addCase(getSalaryTypeById.fulfilled, (state, action) => {
        state.singleSalaryType = action.payload;
        state.isLoading = false;
      })
      .addCase(getQuestionCategoryById.fulfilled, (state, action) => {
        state.singleQuestionCategory = action.payload;
        state.isLoading = false;
      })

      .addCase(getQuestionById.fulfilled, (state, action) => {
        state.singleQuestion = action.payload;
        state.isLoading = false;
      })
      .addCase(getJobQuestionAndAnswer.fulfilled, (state, action) => {
        state.jobQuestionAndAnswer = action.payload;
        state.isLoading = false;
      })
  },
});

export default jobSlice.reducer;
